module.exports = __webpack_public_path__ + "img/un-battant.4b8c26b.svg";